import type { AbschnittCElection19EWResult, CandidateId } from "@/lib/abschnittc/AbschnittCElection";

import type { EvaluatorContext } from "@/lib/abschnittc/impl/EvaluatorContext";

export class AbschnittCElection19EWResultReader {

	constructor(private election: AbschnittCElection19EWResult, private context: EvaluatorContext) {
	}

	highestWithout(id: CandidateId[]): CandidateId[] {
		const votes = Object.entries(this.election.votes).filter(([candidateId, _]) => !id.includes(candidateId));
		const maxVotes = Math.max(...votes.map(([_, votes]) => votes));
		return votes.filter(([_, votes]) => votes === maxVotes).map(([candidateId, _]) => candidateId);
	}

	winner(): CandidateId | undefined {

		const validVotes = Object.entries(this.election.votes).reduce((acc, [_, votes]) => acc + votes, 0);

		this.context.message("text", `Es wurden ${validVotes} gültige Stimmen abgegeben.`);
		this.context.message("text", `Es wurden ${this.election.abstentions} Enthaltungen und ${this.election.invalid} ungültige Stimmen abgegeben.`);

		let quorum = Math.floor(validVotes / 2) + 1;

		let maxVotes = Math.max(...Object.values(this.election.votes));
		let winnerCandidate = undefined;

		for (const [candidateId, votes] of Object.entries(this.election.votes)) {

			this.context.message("text", `Bewerber*in ${this.context.candidateName(candidateId)} hat ${votes} Stimmen erhalten.`);

			if (votes >= quorum) {
				winnerCandidate = candidateId;
			}
		}

		if (winnerCandidate)
			this.context.message("text", `Bewerber*in ${this.context.candidateName(winnerCandidate)} hat die absolute Mehrheit mit ${maxVotes} Stimmen erreicht.`);
		else {
			this.context.message("text", `Kein Bewerber hat die absolute Mehrheit von ${quorum} Stimmen erreicht.`);
		}

		return winnerCandidate;
	}

	runoffCandidates(): CandidateId[] {
		const first = this.highestWithout([]);

		if (first.length >= 2) {
			return first;
		} else {
			const second = this.highestWithout(first);
			return first.concat(second);
		}
	}
}
